import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  emailFilter: '',
  nameFilter: '',
  customerCodeFilter: '',
  deleteFlagFilter: false, // Set initial deleteFlagFilter to null to fetch all users by default
  itemsPerPage: 50, // Set initial items per page
    isFilterApplied: false,
};

const userFilterSlice = createSlice({
  name: 'userFilters',
  initialState,
  reducers: {
    // Action to set filters
    setUserFilters: (state, action) => {
      state.emailFilter = action.payload.emailFilter || '';
      state.nameFilter = action.payload.nameFilter || '';
      state.customerCodeFilter = action.payload.customerCodeFilter || '';
      state.deleteFlagFilter = action.payload.deleteFlagFilter !== undefined ? action.payload.deleteFlagFilter : null; // If undefined, set to null (fetch all)
      state.itemsPerPage = action.payload.itemsPerPage || 50; // Set itemsPerPage from payload or default to 50
     if (typeof action.payload.isFilterApplied === 'boolean') {
        state.isFilterApplied = action.payload.isFilterApplied;
      }
    },
    
    // Action to reset filters to default values
    resetUserFilters: (state) => {
      state.emailFilter = '';
      state.nameFilter = '';
      state.customerCodeFilter = '';
      state.deleteFlagFilter = false; // Reset deleteFlagFilter to null (fetch all)
      state.itemsPerPage = 50; 
        state.isFilterApplied = false;
    },
      setIsFilterApplied: (state, action) => {
      state.isFilterApplied = action.payload;
    },
  },
});

export const { setUserFilters, resetUserFilters  , setIsFilterApplied} = userFilterSlice.actions;

export default userFilterSlice;
